const listeners = {}

export const toastBus = {
  on(event, fn) {
    if (!listeners[event]) listeners[event] = []
    listeners[event].push(fn)
  },
  off(event, fn) {
    if (listeners[event]) listeners[event] = listeners[event].filter(l => l !== fn)
  },
  emit(event, payload) {
    (listeners[event] || []).forEach(fn => fn(payload))
  }
}

export function showToast(message, type = 'error') {
  toastBus.emit('show', { message, type })
}
